import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

export interface DrilldownLimitAlertProps {
  className?: string;
  limit: number;
}

export function DrilldownLimitAlert({
  className,
  limit,
}: DrilldownLimitAlertProps) {
  return (
    <div className={cn("p-4 py-12 text-left", className)}>
      <Alert variant="default">
        <AlertTitle>Drill-down row limit exceeded</AlertTitle>
        <AlertDescription>
          To see data for this drill-down, please apply filters to bring the
          metric below {limit} items.
        </AlertDescription>
      </Alert>
    </div>
  );
}
